import { CareLink } from '@app/core/api/care-links';

export interface CareLinksState {
  caregivers: CareLink[];
  loading: boolean;
  inviting: boolean;
  error: string | null;
}

export const initialCareLinksState: CareLinksState = {
  caregivers: [],
  loading: false,
  inviting: false,
  error: null,
};
